import React from 'react'
import { makeStyles, createStyles, theme } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import Grid from '@material-ui/core/Grid'
import { Typography } from '@material-ui/core/Typography'
import { Link, Redirect } from 'react-router-dom'
import { Button, CircularProgress } from '@material-ui/core'

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      flexGrow: 1,
    },
    paper: {
      padding: theme.spacing(2),
      textAlign: 'center',
      color: theme.palette.text.secondary,
    },
    main: {
      backgroundColor: '#f1f1f1',
      padding: '20px',
      float: 'left',
      textAlign: 'left',
      fontSize: '16px',
      fontFamily: 'Times New Roman',
      color: 'black',
      //   width: "60%",
    },
    heading: {
      textAlign: 'center',
      fontFamily: 'Times New Roman',
      fontWeight: 'bold',
      color: 'black',
    },
    text: { fontSize: '16px', fontFamily: 'Times New Roman', color: 'black' },
  }),
)

const Home = () => {
  const classes = useStyles()
  return (
    <>
      <div className={classes.root}>
        <Grid container spacing={1}>
          <Grid item xs={1} sm={2} md={2} lg={3}>
            {/* <Paper className={classes.paper}>xs=3</Paper> */}
          </Grid>
          <Grid item xs={10} sm={8} md={8} lg={6}>
            <Paper className={classes.main}>
              <h1 className={classes.heading} style={{ fontSize: 33 }}>
                <b>Software End User Licence Agreement</b>
              </h1>
              <Link to="/Rigv-disclaimerAnd">
                <Button color="primary">RigV Android</Button>
              </Link>
              <br />
              <Link to="/Rigv-disclaimerIos">
                <Button color="primary">RigV IOS</Button>
              </Link>
              <br />
              <br />
              {/* school */}
              <Link to="/RigvSchool-disclaimerAnd">
                <Button color="primary">RigV School Android</Button>
              </Link>
              <br />
              <Link to="/RigvSchool-disclaimerIos">
                <Button color="primary">RigV School IOS</Button>
              </Link>
              <br /> <br />

              {/* school */}
              <Link to="/RSBAdmin-disclaimerAnd">
                <Button color="primary">RSB Admin Android</Button>
              </Link>
              <br />
              <Link to="/RSBAdmin-disclaimerIos">
                <Button color="primary">RSB Admin IOS</Button>
              </Link>
              <br /> <br />
              {/* Fitter */}
              <Link to="/RigvFitter-disclaimerAnd">
                <Button color="primary">RigV fitter Android</Button>
              </Link>
              <br />
              <Link to="/RigvFitter-disclaimerIos">
                <Button color="primary">RigV Fitter IOS</Button>
              </Link>
              <br /> <br />
              {/* Inspector */}
              <Link to="/RigvInspector-disclaimerAnd">
                <Button color="primary">RigV Inspector Android</Button>
              </Link>
              <br />
              <Link to="/RigvInspector-disclaimerIos">
                <Button color="primary">RigV Inspector IOS</Button>
              </Link>

              <br /> 
              {/* Green IOT Get Level */}
              {/* <Link to="/greeniot-disclaimerAnd">
                <Button color="primary">Green IOT Get Level Android</Button>
              </Link> */}
              {/* <br /> */}
              {/* <Link to="/greeniot-disclaimerIos">
                <Button color="primary">Green IOT Get Level IOS</Button>
              </Link> */}

              <br /> 
              {/* IOTRIX */}
              <Link to="/iotrix-disclaimerAnd">
                <Button color="primary">IOTRIX Android</Button>
              </Link>
              <br />
              <Link to="/iotrix-disclaimerIos">
                <Button color="primary">IOTRIX IOS</Button>
              </Link>
              <br/><br/>

               {/* IOTRIX */}
               <Link to="/billtrace-disclaimerAnd">
                <Button color="primary">BilltraceCAP Android</Button>
              </Link>
              <br />
              <Link to="/billtrace-disclaimerIos">
                <Button color="primary">BilltraceCAP IOS</Button>
              </Link>
              <br/><br/>

              {/* CORPORATE */}
              <Link to="/corporate-disclaimerAnd">
              <Button color="primary">Corporate RigV Android</Button>
              </Link>
              <br/>
              <Link to="/corporate-disclaimerIos">
                <Button color="primary">Corporate RigV  IOS</Button>
              </Link>
              <br/><br/>
{/* CHILD SAFETY */}
<Link to="/childSafety-disclaimerAnd">
              <Button color="primary">Child Safety RigV Android</Button>
              </Link>
              <br/>
              <Link to="/childSafety-disclaimerIos">
                <Button color="primary">Child Safety RigV  IOS</Button>
              </Link>
              <br/>
              <Link to="/childSafety-disclaimer">
                <Button color="primary">Green RigV Child Safety</Button>
              </Link>
            </Paper>
          </Grid>
          <Grid item xs={1} sm={2} md={2} lg={3}>
            {/* <Paper className={classes.paper}>xs=3</Paper> */}
          </Grid>
          
        </Grid>
      </div>
    </>
  )
}
export default Home
